exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright (c) 2016-present, Parse, LLC\n * All rights reserved.\n *\n * This source code is licensed under the license found in the LICENSE file in\n * the root directory of this source tree.\n */\n.note__2TE {\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  margin-top: 10px;\n  margin-bottom: -10px;\n  color: #fff;\n  font-size: 13px;\n  line-height: 1.4; }\n\n.blue__14L {\n  background: #0092ff; }\n\n.green__SSJ {\n  background: #00db7c; }\n\n.orange__vZk {\n  background: #fd9539; }\n\n.red__9ZL {\n  background: #ff395e; }\n", ""]);
// Exports
exports.locals = {
	"note": "note__2TE",
	"blue": "blue__14L",
	"green": "green__SSJ",
	"orange": "orange__vZk",
	"red": "red__9ZL"
};